















































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import _ from 'lodash'
import EventBus from '@/plugins/EventBus'
import SuportePacientesStore, { ContextoDB } from '@/components/Suporte/Store/SuportePacientesStore'
import { DataTablePagination } from '@/types/_'
import { maskDate } from '@/utils/common'

@Component
export default class ViewSuporteSalasCentrosCirurgicos extends Vue {
  loadPacientes: boolean = false
  loadEditPaciente: string = ''

  get getSuportePacientesStore() {
    return getModule(SuportePacientesStore, this.$store)
  }

  get contextoDB() { return this.getSuportePacientesStore.contextoDB }
  set contextoDB(value: ContextoDB) { this.getSuportePacientesStore.setContextoDB(value) }

  get paginationPacientes() { return this.getSuportePacientesStore.paginationPacientes }

  get loadingPacientes() { return this.loadPacientes }
  set loadingPacientes(value: boolean) { this.loadPacientes = value }
  get loadingEditPaciente() { return this.loadEditPaciente }
  set loadingEditPaciente(value: string) { this.loadEditPaciente = value }

  get pacientesHeaders() {
    return [
      { text: 'Nome', value: 'nome', sortable: false },
      { text: 'CPF', value: 'cpf', sortable: false },
      { text: 'Data de nascimento', value: 'dataNascimento', align: 'center', sortable: false },
    ]
  }

  get pacientes() { return this.getSuportePacientesStore.pacientes }
  get searchPaciente() { return this.getSuportePacientesStore.searchPaciente }
  set searchPaciente(value: string) { this.getSuportePacientesStore.setSearchPaciente(value) }

  @Watch('searchPaciente')
  async onChangeSearchPaciente(value: any) {
    this.pacientesPagedDebounce({ ...this.paginationPacientes })
  }

  async contextoChange(value: ContextoDB) {
    this.getSuportePacientesStore.setSearchPaciente('')
    this.getSuportePacientesStore.setContextoDB(value)

    const params: any = { contextoDB: value }

    this.loadingPacientes = true
    await this.getSuportePacientesStore.getPacientesPagedSearch({
      ...params,
      ...this.getSuportePacientesStore.pacientePaginationDefault,
    })
    this.loadingPacientes = false
  }

  pacientesPagedDebounce = _.debounce(param => this.getSuportePacientesStore.getPacientesPagedSearch(param), 700)

  async updatePaginationPacientes(pagination: DataTablePagination) {
    if (['', null, undefined].includes(this.contextoDB)) return
    this.loadingPacientes = true
    this.pacientesPagedDebounce(pagination)
    this.loadingPacientes = false
  }

  async editarPaciente(id: string) {
    this.loadingEditPaciente = id
    await this.getSuportePacientesStore.getPacienteById(id)
    this.getSuportePacientesStore.setMode('EDIT')
    this.getSuportePacientesStore.setModal({ name: 'paciente', value: true })
    this.loadingEditPaciente = ''
  }

  async mounted() {
    EventBus.$emit('setLoadingRequest', { status: true, text: 'Carregando...' })
    // @ts-ignore
    await this.getSuportePacientesStore.getPacientesPagedSearch(this.getSuportePacientesStore.paginationPacientes)
    await this.getSuportePacientesStore.getPaisAll()
    EventBus.$emit('clearLoadingRequest')
  }

  maskDateUtil(value: string) {
    return maskDate(value)
  }

  beforeDestroy() {
    this.getSuportePacientesStore.clearPacientes()
    this.getSuportePacientesStore.setContextoDB('FinxAgendamentoContext')
    this.getSuportePacientesStore.setPaises([])
  }
}
